window.addEventListener("load", (e) => {
    document.querySelectorAll(".block-multi_hero").forEach((block) => {
        block.querySelectorAll('.block-control').forEach((button) => {
            button.onclick = function (e) {
                block.querySelector('.block-control.toggled').classList.remove('toggled');
                button.classList.add('toggled');
                block.querySelector('.block-repeater.toggled').classList.remove('toggled');
                block.querySelector('.block-repeater[data-index="'+button.dataset.index+'"]').classList.add('toggled');
                block.querySelector('.hero-image.toggled').classList.remove('toggled');
                block.querySelector('.hero-image[data-index-number="'+button.dataset.index+'"]').classList.add('toggled');
                const heroImageLinkActive = block.querySelector('.hero-image-link.toggled')
                if (!!heroImageLinkActive) heroImageLinkActive.classList.remove('toggled');
                const heroImageLinkUnactive = block.querySelector('.hero-image-link[data-index="'+button.dataset.index+'"]');
                if(!!heroImageLinkUnactive) heroImageLinkUnactive.classList.add('toggled');
            }
        })
    })
});
